import React, { Component } from 'react'
import App from './App';
import { HOST } from "./config";
import './AuthoritionPage.css'
import axios from "axios";

export default class AuthoritionPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            login: '',
            password: '',
            submitOk: false,
            showpassword: 0,
            User: null,
            Chek: null,
            Logout: [],
            status: null
        }
    }
    componentDidMount() {
        this.check()
    }
    check = () => {
        axios
            .post(
                `${HOST}/api/okno/check?`, {}, { withCredentials: true }
            )
            .then((response) => response.data)
            .then((json) => {
                this.setState({
                    User: json
                });
            });
    }

    postLogin = (login, password) => {
        axios
            .post(
                `${HOST}/api/okno/login`, { username: login, password }, { withCredentials: true }
            )
            .then((response) => response.data)
            .then((json) => {
                this.setState({
                    User: json,
                    status: json.status
                });
                this.check()
            });
    }
    postLogout = () => {
        axios
            .post(
                `${HOST}/api/okno/logout`, { withCredentials: true }
            )
            .then((response) => response.data)
            .then((json) => {
                this.setState({
                    Logout: json.status
                })
            });

        setTimeout(() => {
            this.setState({ Logout: [], User: null })
        }, 100);
    }

    onSubmit = formSubmitEvent => {
        formSubmitEvent.preventDefault();
        this.postLogin(this.state.login, this.state.password)

    };

    onChangeLogin = (e) => {
        this.setState({ login: e.target.value })
    }
    onChangePassword = (e) => {
        this.setState({ password: e.target.value })
        if (e.target.value.length === 0) {
            this.showPassword(0)
        }
    }
    showPassword = (showpassword) => {
        this.setState({ showpassword })
        if (this.state.password.length === 0) {
            this.setState({ showpassword: 0 })
        }
    }

    render() {
        const page = new URLSearchParams(window.location.search).get("page")
        const { User } = this.state
        if (User && User === null) return null;
        return (
            <div className='AuthoritionPage'>
                {User && User.status === 200 && this.state.Logout && this.state.Logout !== 200 ?
                    <App id_AVN_User={User.id}
                        user_fio={User.name}
                        doljnost={User.doljnost}
                        Timesheet_report={User.Timesheet_report}
                        AVN20={User.AVN20} postLogout={this.postLogout.bind(this)} /> :
                    <div className='D_main_header AuthoritionPage_header'>
                        <header>
                            <img src={`${HOST}/okno/images/avnlogo.png`} alt="img1" />
                            <h2>ТАБЕЛЬ УЧЕТА РАБОЧЕГО ВРЕМЕНИ</h2>
                            <div className='Header_fio_container'>
                                <h4>{this.props.user_fio}</h4>
                            </div>
                        </header>
                        <form onSubmit={this.onSubmit} className='AuthoritionBlock'>
                            <h3>Авторизация</h3>
                            <div className="pass-wrapper">
                                <input
                                    name="username"
                                    type="text"
                                    placeholder="Логин"
                                    autocomplete="username"
                                    required="This is required."
                                    onChange={this.onChangeLogin}
                                />
                                <i className="fas fa-user"></i>
                            </div>
                            <div className="pass-wrapper">
                                <input
                                    placeholder="Пароль"
                                    name="password"
                                    autocomplete="current-password"
                                    type={this.state.showpassword === 0 ? "password" : 'text'}
                                    required="This is required."
                                    onChange={this.onChangePassword}
                                />
                                {this.state.showpassword === 1 ? <i className="fas fa-lock-open" onClick={() => this.showPassword(0)}></i> :
                                    <i className='fa fa-lock' onClick={() => this.showPassword(1)}></i>}
                            </div>
                            <button type="submit">
                                Вход
                            </button>
                            {this.state.status && this.state.status === 500 ?
                                <h4 className='err_message'>Неправильный логин или пароль!</h4> : null}
                        </form>

                    </div>}
            </div>
        )
    }
}
